import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Copy, Flex, Box, HorizontalRule, Currency } from '@elparking/components'

import Breakdown from './Breakdown'

import LoadingBlock from 'commons/js/ui/LoadingBlock'
const PaymentInfo = ({
    price,
    isLoading,
    promoCode,
    onDeletePromoCode,
}) => (
    <Box>
        <Breakdown
          price={price}
          isLoading={isLoading}
          promoCode={promoCode}
          onDeletePromoCode={onDeletePromoCode}
        />
        <HorizontalRule height='2px' />
        <Flex mb='8px' justifyContent='space-between' w='100%' alingItem='center'>
            <Copy padding='0' fontSize={['small', 'xxLarge']} fontWeight='regular' color='black'>
                <FormattedMessage defaultMessage='Total' />
            </Copy>
            <Copy padding='0' transform='uppercase' fontSize={['small', 'xxLarge']} fontWeight='medium' color='black'>
                {isLoading ? <LoadingBlock size={['small', 'xxLarge']} width='40px' /> : <Currency qty={price.totalPriceQty} />}
            </Copy>
        </Flex>
    </Box>
)

PaymentInfo.propTypes = {
    onDeletePromoCode: PropTypes.func,
    isLoading: PropTypes.bool.isRequired,
    promoCode: PropTypes.object,
    price: PropTypes.shape({
        totalPriceQty: PropTypes.shape({
            amount: PropTypes.number,
            currency: PropTypes.string,
        }).isRequired,
    }),
}

export default PaymentInfo
